var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProduto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9221BCEE-9866-46E5-9590-7D82D68DFAFE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Maio---indique-um-amigo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "indique-v2-1",
    transform: "translate(-240.000000, -885.000000)",
    fill: "#FF6A58",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-produto",
    transform: "translate(240.000000, 885.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.13371828,5.11377754 C9.3899084,4.66951723 9.93547586,4.49621341 10.3951682,4.69462097 L10.4995558,4.74705162 L22.4995558,11.6670516 C22.97799,11.9429487 23.1421788,12.5544549 22.8662817,13.0328891 C22.6100916,13.4771494 22.0645241,13.6504533 21.6048318,13.4520457 L21.5004442,13.3996151 L9.50044421,6.47961505 C9.02201003,6.20371801 8.85782124,5.59221172 9.13371828,5.11377754 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1666667,2.16064126 L4.83333386,7.49397429 C3.70002571,8.14828914 3.0013428,9.35701058 3,10.665641 L3,21.3333333 C3.0013428,22.6429894 3.70002571,23.8517109 4.83333386,24.5060257 L14.1705277,29.8415765 C15.3011373,30.4943457 16.6988627,30.4943457 17.8333333,29.8393587 L27.1628056,24.5082431 C28.2999743,23.8517109 28.9986572,22.6429894 29,21.334359 L29,10.6666667 C28.9986572,9.35701058 28.2999743,8.14828914 27.1666661,7.49397429 L17.8294723,2.15842352 C16.6988627,1.50565435 15.3011373,1.50565435 14.1666667,2.16064126 Z M16.8333333,3.89269207 L26.1705277,9.22824314 C26.6818073,9.52344155 26.9993904,10.0728604 26.9999995,10.6676924 L26.9999995,21.3333333 C26.9993904,21.9271396 26.6818073,22.4765585 26.1666672,22.7739743 L16.8371944,28.1050902 C16.3176649,28.4050293 15.6823351,28.4050293 15.1666667,28.1073079 L5.82947227,22.7717569 C5.31819274,22.4765585 5.0006096,21.9271396 4.99999947,21.3323076 L4.99999947,10.6666667 C5.0006096,10.0728604 5.31819274,9.52344155 5.82947227,9.22824314 L15.1628056,3.89490981 C15.6823351,3.59497075 16.3176649,3.59497075 16.8333333,3.89269207 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1392764,8.41439274 C27.6173381,8.13785076 28.2290653,8.30121476 28.5056073,8.77927644 C28.7623962,9.22319087 28.6398785,9.78235765 28.2383029,10.0813887 L28.1407236,10.1456073 L16.5007236,16.8789406 C16.229676,17.0357321 15.9033953,17.0553311 15.6185395,16.9377374 L15.4992764,16.8789406 L3.85927644,10.1456073 C3.38121476,9.86906527 3.21785076,9.25733813 3.49439274,8.77927644 C3.75118173,8.33536202 4.29698241,8.16279408 4.75640673,8.36182137 L4.86072356,8.41439274 L15.999,14.857 L27.1392764,8.41439274 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,15 C16.5128358,15 16.9355072,15.3860402 16.9932723,15.8833789 L17,16 L17,29.44 C17,29.9922847 16.5522847,30.44 16,30.44 C15.4871642,30.44 15.0644928,30.0539598 15.0067277,29.5566211 L15,29.44 L15,16 C15,15.4477153 15.4477153,15 16,15 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProduto);
export default __webpack_public_path__ + "static/media/ic-produto.bf74969795cb6ac757b85938d8f05bc7.svg";
export { ForwardRef as ReactComponent };